import styled from '@emotion/styled';
import { colors, Typography } from '@ui-components/neo.tax';

export type InstructionListProps = {
  $listStyle?: React.CSSProperties['listStyleType'];
};

export const InstructionList = styled.ol<InstructionListProps>(({ $listStyle }) => ({
  textAlign: 'left',
  listStyle: $listStyle || 'disc',
  paddingLeft: 40,
}));

export const InstructionListItem = styled.li({
  fontSize: 14,
  lineHeight: 1.5,
  color: colors.gray[500],
  textAlign: 'left',
});

export const InstructionsIntroText = styled(Typography)({
  color: colors.gray[500],
});
